import type { Except } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import type { ComponentProps } from 'react'

type Props = Except<ComponentProps<typeof Button>, 'variant' | 'startIcon'>

export const PersonaBadge = ({ children, ...restProps }: Props) => (
  <Button {...restProps} variant="primary" startIcon="User">
    {children}
  </Button>
)
